import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'ew-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
})
export class OnboardingComponent implements OnInit {
  constructor(private AR: ActivatedRoute, public AUTH: AuthService) {}

  ngOnInit(): void {
    this.AR.queryParamMap.subscribe((query) => {
      const agencyCompanyId = query.get('agencyCompanyId');
      const agencyCompanyName = query.get('agencyCompanyName');
      const platform = query.get('platform');
      const redirect = query.get('redirect');

      if (agencyCompanyId && agencyCompanyName && platform && redirect) {
        localStorage.setItem('agencyCompanyId', agencyCompanyId);
        localStorage.setItem('agencyCompanyName', agencyCompanyName);
        localStorage.setItem('platform', platform);
        localStorage.setItem('redirect', redirect);
      }

      this.AUTH.loginWithRedirect({
        appState: {
          target: '/profile',
        },
        authorizationParams: {
          screen_hint: 'signup',
        },
      });
    });
  }
}
